import React from "react";
import { motion } from "framer-motion";
import { GENERI } from "../lib/data";

const Generi = () => {
  return (
    <section
      id="generi"
      className="relative py-28 md:py-40 bg-[var(--pw-surface)] overflow-hidden"
      data-testid="generi-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 mb-20 items-end">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-4 mb-6">
              <span className="gold-line" />
              <span className="overline">Repertorio</span>
            </div>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl leading-[1.05] text-[var(--pw-text)]">
              Ogni <em className="text-[var(--pw-gold)]">genere</em>,
              ogni <em className="text-[var(--pw-gold)]">epoca</em>:
              la colonna sonora è vostra.
            </h2>
          </div>
          <p className="lg:col-span-5 text-[var(--pw-text)]/65 font-light text-base md:text-lg">
            Costruiamo un repertorio personalizzato attingendo dalla classica alla
            colonna sonora, dal jazz al pop. Possiamo imparare nuovi brani su richiesta,
            purché concordati con il giusto anticipo.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px]">
          {GENERI.map((g, i) => (
            <motion.div
              key={g.name}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className={`card-pw p-6 flex flex-col justify-between group cursor-default ${
                g.tall ? "row-span-2" : ""
              }`}
              data-testid={`genere-${g.name.toLowerCase().replace(/\s+/g, "-")}`}
            >
              <div className="font-serif italic text-[var(--pw-text)]/30 text-sm">
                — {String(i + 1).padStart(2, "0")}
              </div>
              <div>
                <h3 className="font-serif font-light text-2xl md:text-3xl text-[var(--pw-text)] group-hover:text-[var(--pw-gold)] transition-colors duration-500">
                  {g.name}
                </h3>
                <p className="mt-2 text-xs text-[var(--pw-text)]/50 font-light">
                  {g.hint}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Generi;
